import { render, staticRenderFns } from "./List.vue?vue&type=template&id=04e8b4fe"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {KnowledgeItem: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/KnowledgeItem.vue').default})
